import { Clear, Search } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

export interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  fullWidth?: boolean;
  size?: "small" | "medium";
  sx?: object;
  onKeyDown?: React.KeyboardEventHandler;
  onClear?: () => void;
  disabled?: boolean;
}

export const SearchField = ({
  value,
  onChange,
  placeholder = "Search...",
  fullWidth = true,
  size = "small",
  sx,
  onKeyDown,
  onClear,
  disabled,
}: SearchFieldProps) => {
  return (
    <TextField
      fullWidth={fullWidth}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      size={size}
      sx={sx}
      value={value}
      onKeyDown={onKeyDown}
      variant="outlined"
      disabled={disabled}
      slotProps={{
        input: {
          endAdornment: value && onClear && (
            <InputAdornment position="end">
              <IconButton onClick={onClear} size="small" edge="end" aria-label="clear search">
                <Clear />
              </IconButton>
            </InputAdornment>
          ),
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
